import { render, staticRenderFns } from "./LiffPageList.vue?vue&type=template&id=1a2aa254&scoped=true&"
import script from "./LiffPageList.vue?vue&type=script&lang=js&"
export * from "./LiffPageList.vue?vue&type=script&lang=js&"
import style0 from "./LiffPageList.vue?vue&type=style&index=0&id=1a2aa254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2aa254",
  null
  
)

export default component.exports